import Api from '../../shared/Api';

class InvoiceJournalApi {
    static getInvoiceJournalList(): Promise<any> {
        return new Api().get('/views/invoice-journal');
    }

    static getInvoiceJournal(id: number): Promise<any> {
        return new Api().get('/views/invoice-journal/' + id);
    }

    static createInvoiceJournal(
        legalEntityId: number,
        site: number,
        createForeign: boolean
    ): Promise<any> {
        return new Api().post('/views/invoice-journal', {
            legalEntityId: legalEntityId,
            site: site,
            createForeign: createForeign
        });
    }
}

export default InvoiceJournalApi;
